module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fa2c5c6d9dd6e5c64724929ebcf0841d.png";